// Make TypeScript work with global YT-values
import { YouTube } from './models/youtube';

declare global {
  interface Window {
    YT: any;
    onYouTubeIframeAPIReady: Function;
  }
}


let youTubeObject: YouTube = {
    initialized: false,
    players: [],

    initialize: function() {
        if (!this.initialized && !!window.Cookiebot && !!window.Cookiebot.consent && window.Cookiebot.consent.marketing && !document.getElementById("youtube-iframe-api")) {
          let anyYouTubePlayers = document.querySelectorAll(".video-block__content--youtube").length;

          if (!!anyYouTubePlayers) {
            let tag = document.createElement("script");
            let firstScriptTag = document.querySelector("script");

            tag.src = "https://www.youtube.com/iframe_api";
            tag.id = "youtube-iframe-api";
            tag.className ="dynamic-added-script"
            
            if (!!firstScriptTag) {
              firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
              this.initialized = true;
            }
          }
        }
    },

    createPlayer: function(height: string | undefined, width: string | undefined, videoId: string | undefined, ytPlayerId: string | undefined, onPlayerStateChange: Function) {
        let player = new window.YT.Player(ytPlayerId, {
            videoId: videoId,
            playerVars: {
                "playsinline": 1,
                "rel": 0
            },
            events: {
                "onReady": (event: any) => {
                    if (document.querySelector("body")?.classList.contains("isIOS")) {
                        event.target.mute();
                    }
                    
                    event.target.playVideo();
                },
                "onStateChange": (event: any) => {
                    onPlayerStateChange(event, ytPlayerId)
                }
            }
        });

        this.players.push({ytPlayerId: ytPlayerId, player: player});
    },

    playYouTubeVideo: function(blockElement: any) {
        let playerObject: any = this.players.find((x: { ytPlayerId: string | undefined, player: any }) => x.ytPlayerId == blockElement.dataset.ytplayerid);
        
        if(!!playerObject){
          playerObject.player.playVideo(); 
        }
    }
}

// If this script was loaded before YouTube related scripts, dispatch the loaded event again
document.addEventListener('YouTubeRelatedScriptLoaded', function(e) {
    document.dispatchEvent(new CustomEvent("YouTubeScriptLoaded"));
});

window.JVM.YouTube = youTubeObject;

// Tell other modules that this script is loaded
document.dispatchEvent(new CustomEvent("YouTubeScriptLoaded"));